import script from "./LtSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./LtSummary.vue?vue&type=script&setup=true&lang=js"

import "./LtSummary.vue?vue&type=style&index=0&id=0820c275&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0820c275"]])

export default __exports__